import { render, staticRenderFns } from "./LyActivityRule.vue?vue&type=template&id=35bf496b&"
import script from "./LyActivityRule.vue?vue&type=script&lang=js&"
export * from "./LyActivityRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports